import React from "react";

const StartCountdown = ({openCountDownAnimation, isSoundOn, volume, setVolume}) => {

    const startCountdownClickSound = () => {
        const audio_start_countdown_click = new Audio('sound/button_sound/Start_Count_BTN.ogg');
        audio_start_countdown_click.volume = volume / 100;
        audio_start_countdown_click.play();
    }

    return (
        <div>
            <button className="common-but start-countdown-but" onClick={() => { openCountDownAnimation(); isSoundOn && startCountdownClickSound(); }}>
                Start countdown
            </button>
        </div>
    );

};

export default StartCountdown;